import { useState, type ReactNode } from "react";
import type { TrainingEvalRunSummaryView } from "@/api/trainingEval";
import { RightSidePanel } from "@/components/modal";
import { EvalRunDetailPanel } from "../EvalRunDetailPanel";
import { EvaluationComparisonViewer } from "./EvaluationComparisonViewer";
import { useEvalCompareController } from "./useEvalCompareController";

// 비교·병합 side panel 이다. Evaluation Results 창의 로컬 뷰 상태에 따라 그린다.
// 마운트는 열림을 뜻한다. 닫아서 언마운트하면 로드한 비교 데이터도 함께 버린다.
export function EvalComparePanel({
  mode,
  runs,
  slotById,
  onClose,
}: {
  mode: "compare" | "merge";
  runs: readonly TrainingEvalRunSummaryView[];
  slotById: Readonly<Record<string, number>>;
  onClose: () => void;
}): ReactNode {
  const controller = useEvalCompareController(runs, slotById, true, mode === "compare");
  // 상세는 이 패널에 속한 드릴다운이다. 그래서 URL 이 아니라 이 컴포넌트가 소유한다. URL 에
  // 담으면 비교 뷰 파라미터와 상세 파라미터가 같은 키(view)를 두고 충돌한다.
  const [detailRun, setDetailRun] = useState<TrainingEvalRunSummaryView | null>(null);

  return (
    <>
      <RightSidePanel
        title={`Evaluation ${mode === "merge" ? "통합" : "비교"} · 실행 ${runs.length}개`}
        width={{ kind: "flex", percent: 80 }}
        onBackdrop={onClose}
        onRequestClose={onClose}
      >
        <EvaluationComparisonViewer
          controller={controller}
          mode={mode}
          onOpenRunDetail={setDetailRun}
        />
      </RightSidePanel>

      {/* run id 를 key 로 준다. 다른 칩을 눌러 run 을 바꾸면 콘텐츠를 새로 만든다. 그래서 로그 버퍼와
          주석 초안 같은 내부 상태가 이전 run 의 값으로 남지 않는다. 이 패널보다 나중에 마운트되므로
          등록 순서만으로 위에 겹친다. 아래의 비교 패널은 modalStack 이 잠근다. */}
      {detailRun !== null ? (
        <EvalRunDetailPanel key={detailRun.id} run={detailRun} onClose={() => setDetailRun(null)} />
      ) : null}
    </>
  );
}
